import {toast, ToastContainer} from "react-toastify";
import TitleComponent from "../../../components/TitleComponent/TitleComponent";
import QrCodeScanner from "../../../components/QrCodeScanner/QrCodeScanner";
import React, {useCallback, useState} from "react";
import * as Yup from "yup";
import {useFormik} from "formik";
import {isporuciPaketeQRApi} from "../../../api/paketiPanela";
import notifyToast from "../../../components/Toast/Toast";
import {RedomatModel} from "../../../models/Redomat";
import {fetchRedomat, updateRedomat} from "../../../api/redomat";

interface Props {
    Pocetak: 0 | 1;
}
const RedomatUtovar: React.FC<Props> = ({ Pocetak }) => {
    const initialValues = {paket: "" as string};
    const [loading, setLoading] = useState(false);
    const [item, setItem] = useState<RedomatModel | null>(null);
    const [izvoz, setIzvoz] = useState(false);

    const validationSchema = Yup.object({
        paket: Yup.string().required("Required"),
    });

    const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setIzvoz(e.target.checked);
    };

    // Extract first integer from any QR/text (e.g. "ID=123", "123", "R-123-X")
    const extractId = useCallback((raw: string): number | null => {
        const match = (raw || "").toString().match(/\d+/);
        if (!match) return null;
        const n = Number(match[0]);
        return Number.isFinite(n) ? n : null;
    }, []);

    const handleQrScan = (data: string) => {
        formik.setFieldValue("paket", data);
        // Fire fetch immediately for scanner usage
        const id = extractId(data);
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: async (_values, {setStatus, setSubmitting}) => {
            try {
                setLoading(true);
                // Use ID from the current field (or from fetched item)
                const id = extractId(formik.values.paket || "") ?? item?.Id ?? null;
                if (id === null) {
                    notifyToast(false, "Nema validnog ID-a.");
                    return;
                }
                // Only Id in params; body is { pocetak: 1 }
                const res = await updateRedomat(id, {Pocetak: Pocetak, Izvoz: izvoz});

                notifyToast(true, "Utovar potvrđen.");
                // Optionally refresh fetched item to reflect new Status/timestamps
                try {
                    const ref = await fetchRedomat(id);
                    setItem(ref.data);
                } catch {
                }

            } catch (error: any) {
                console.error("Error: ", error);
                notifyToast(false, error?.response?.data?.message || "Došlo je do greške.");
                setStatus(error);
            } finally {
                setLoading(false);
                setSubmitting(false);
            }
        },
    });

    return (
        <div className='row'>

            <div className='card mb-5 mb-xl-10 col-10'>
                <div
                    className='card-header border-0 cursor-pointer'
                    role='button'
                    data-bs-target='#kt_account_profile_details'
                    aria-expanded='true'
                    aria-controls='kt_account_profile_details'
                >
                    <div className='card-title m-0'>
                        <TitleComponent name={Pocetak === 1 ? 'Početak utovara' : 'Kraj utovara'} />
                    </div>
                </div>
                <ToastContainer />
                <div id='kt_account_profile_details' className='collapse show'>

                    <form onSubmit={formik.handleSubmit} noValidate>
                        <div className='card-body border-top p-9 row'>
                            {/* Artikal */}
                            <div className='col-12 mb-6'>
                                <label className='col-auto col-form-label required fw-bold fs-6'>Skeniraj</label>
                                <div className='row mb-5'>
                                    <div className='col-3 fv-row'>
                                        <QrCodeScanner onScan={handleQrScan}/>
                                    </div>
                                    <div className='col-9 mb-5 fv-row'>
                                        <input
                                            type='text'
                                            placeholder='Redomat broj'
                                            {...formik.getFieldProps('paket')}
                                            className='form-control'
                                        />
                                    </div>
                                    {Pocetak === 1 && (
                                    <div className='col-9 fv-row mt-5'>
                                        <div className="form-check form-switch">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                role="switch"
                                                id="flexSwitchCheckDefault"
                                                checked={izvoz}
                                                onChange={handleCheckboxChange}
                                            />
                                            <label
                                                className="form-check-label"
                                                htmlFor="flexSwitchCheckDefault"
                                            >
                                                Utovar za izvoz
                                            </label>
                                        </div>
                                    </div>
                                    )}
                                </div>
                                <div className='row mt-5'>
                                    <div className='col-lg-8 mt-5 fv-row'>
                                        <div className="d-grid gap-2">
                                        <button
                                                type='submit'
                                                className='btn btn-block btn-primary'
                                                disabled={loading || formik.isSubmitting || !formik.isValid}
                                            >
                                                {!loading && 'Potvrdi'}
                                                {loading && (
                                                    <span className='indicator-progress' style={{display: 'block'}}>
                                                    Please wait...{' '}
                                                        <span
                                                            className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                                    </span>
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}
export default RedomatUtovar;
